// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
var Tooltip = require("../../../reason/common/Tooltip.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
var ShowingsUtils = require("../../../v5/common/ShowingsUtils.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var AgentMatchLogTexts = require("../../../v5/agentMatchLog/AgentMatchLogTexts.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var NotificationsAndAlertsUtils = require("../../../v5/common/notifications/NotificationsAndAlertsUtils.bs.js");
var NotificationWidgetTexts_showing_graphql = require("../../../__generated__/NotificationWidgetTexts_showing_graphql.bs.js");
var NotificationWidgetTextsBuyerNeed_aml_graphql = require("../../../__generated__/NotificationWidgetTextsBuyerNeed_aml_graphql.bs.js");
var NotificationWidgetTextsRentalNeed_aml_graphql = require("../../../__generated__/NotificationWidgetTextsRentalNeed_aml_graphql.bs.js");
var NotificationWidgetTextsRentalProperty_aml_graphql = require("../../../__generated__/NotificationWidgetTextsRentalProperty_aml_graphql.bs.js");
var NotificationWidgetTextsForSaleProperty_aml_graphql = require("../../../__generated__/NotificationWidgetTextsForSaleProperty_aml_graphql.bs.js");

var convertFragment = NotificationWidgetTexts_showing_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationWidgetTexts_showing_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationWidgetTexts_showing_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationWidgetTexts_showing_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationWidgetTexts_showing_graphql.node, convertFragment, fRef);
}

var ShowingFragment_visibilityReason_decode = NotificationWidgetTexts_showing_graphql.Utils.visibilityReason_decode;

var ShowingFragment_visibilityReason_fromString = NotificationWidgetTexts_showing_graphql.Utils.visibilityReason_fromString;

var ShowingFragment = {
  visibilityReason_decode: ShowingFragment_visibilityReason_decode,
  visibilityReason_fromString: ShowingFragment_visibilityReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function NotificationWidgetTexts$ShowingNotification(props) {
  var showing = use(props.showing);
  var agentId = NotificationsAndAlertsUtils.AgentId.useForSaleAgentId(showing.property.agentV2.fragmentRefs);
  var agentText = NotificationsAndAlertsUtils.AgentText.useForSaleAgentText(showing.property.agentV2.fragmentRefs);
  var verb = agentText === "You" ? "are" : "is";
  var shouldShowPropertyDetails = UserSession.useShouldShowPropertyDetails(agentId);
  var $$location = NotificationsAndAlertsUtils.PropertyLocationLabel.getLabel(showing.property.fragmentRefs, undefined);
  var duration = ShowingsUtils.formatShowingTimes(showing.startDateV2, showing.endDateV2);
  var match = showing.property.propertyLocation;
  var match$1;
  if (match !== undefined) {
    switch (match.__typename) {
      case "PropertyLocationWithHiddenAddress" :
          match$1 = [
            undefined,
            match.locationDisplay,
            undefined
          ];
          break;
      case "PropertyLocationWithVisibleAddress" :
          match$1 = [
            match.address,
            match.locationDisplay,
            match.visibilityRule
          ];
          break;
      case "__unselected" :
          match$1 = [
            undefined,
            "-",
            undefined
          ];
          break;
      
    }
  } else {
    match$1 = [
      undefined,
      "-",
      undefined
    ];
  }
  var visibilityRule = match$1[2];
  var locationDisplay = match$1[1];
  var address = match$1[0];
  var tmp;
  if (shouldShowPropertyDetails) {
    var tmp$1;
    if (address !== undefined) {
      var exit = 0;
      if (visibilityRule !== undefined) {
        var exit$1 = 0;
        if (visibilityRule === "VISIBLE_TO_ALL" || visibilityRule === "VISIBLE_TO_ACCOUNT_MEMBER" || visibilityRule === "VISIBLE_TO_TAN_STAFF") {
          switch (visibilityRule) {
            case "VISIBLE_TO_ALL" :
                exit = 1;
                break;
            case "VISIBLE_TO_ACCOUNT_MEMBER" :
            case "VISIBLE_TO_TAN_STAFF" :
                exit$1 = 2;
                break;
            
          }
        } else {
          exit = 1;
        }
        if (exit$1 === 2) {
          var tmp$2;
          if (visibilityRule === "VISIBLE_TO_ALL" || visibilityRule === "VISIBLE_TO_ACCOUNT_MEMBER" || visibilityRule === "VISIBLE_TO_TAN_STAFF") {
            switch (visibilityRule) {
              case "VISIBLE_TO_ACCOUNT_MEMBER" :
                  tmp$2 = " (only visible to you)";
                  break;
              case "VISIBLE_TO_ALL" :
                  tmp$2 = "";
                  break;
              case "VISIBLE_TO_TAN_STAFF" :
                  tmp$2 = " (visible to TAN staff)";
                  break;
              
            }
          } else {
            tmp$2 = "";
          }
          tmp$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx("span", {
                        children: locationDisplay
                      }),
                  JsxRuntime.jsx("span", {
                        children: JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(IconV5.make, {
                                      icon: "lock",
                                      size: 16,
                                      className: "text-gray-600 mr-1"
                                    }),
                                JsxRuntime.jsx(Tooltip.make, {
                                      label: address + tmp$2,
                                      children: JsxRuntime.jsx("div", {
                                            children: "Hidden Address",
                                            className: "border-dotted border-b border-gray-400"
                                          })
                                    })
                              ],
                              className: "inline-flex flex-row items-center lg:before:content-['('] lg:after:content-[')'] before:content-none after:content-none"
                            }),
                        className: ""
                      })
                ]
              });
        }
        
      } else {
        exit = 1;
      }
      if (exit === 1) {
        tmp$1 = JsxRuntime.jsx("span", {
              children: address + " in " + locationDisplay
            });
      }
      
    } else {
      tmp$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx("span", {
                    children: locationDisplay
                  }),
              JsxRuntime.jsx("span", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(IconV5.make, {
                                  icon: "lock",
                                  size: 16,
                                  className: "text-gray-600 mr-1"
                                }),
                            JsxRuntime.jsx("div", {
                                  children: "Contact agent for address"
                                })
                          ],
                          className: "ml-1 inline-flex flex-row items-center lg:before:content-['('] lg:after:content-[')'] before:content-none after:content-none"
                        }),
                    className: ""
                  })
            ]
          });
    }
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            agentText,
            " " + verb + " showing ",
            JsxRuntime.jsx("span", {
                  children: tmp$1,
                  className: ""
                })
          ]
        });
  } else {
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            "A TAN agent is showing ",
            $$location
          ]
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                tmp,
                JsxRuntime.jsx("br", {}),
                duration
              ]
            });
}

var ShowingNotification = {
  ShowingFragment: ShowingFragment,
  make: NotificationWidgetTexts$ShowingNotification
};

var convertFragment$1 = NotificationWidgetTextsForSaleProperty_aml_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationWidgetTextsForSaleProperty_aml_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationWidgetTextsForSaleProperty_aml_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationWidgetTextsForSaleProperty_aml_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationWidgetTextsForSaleProperty_aml_graphql.node, convertFragment$1, fRef);
}

var AmlFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function NotificationWidgetTexts$PropertyMatchText(props) {
  var __withLinks = props.withLinks;
  var withLinks = __withLinks !== undefined ? __withLinks : false;
  var aml = use$1(props.aml);
  return JsxRuntime.jsx(AgentMatchLogTexts.PropertyMatchText.make, {
              aml: aml.fragmentRefs,
              withLinks: withLinks
            });
}

var PropertyMatchText = {
  AmlFragment: AmlFragment,
  make: NotificationWidgetTexts$PropertyMatchText
};

var convertFragment$2 = NotificationWidgetTextsRentalProperty_aml_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationWidgetTextsRentalProperty_aml_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationWidgetTextsRentalProperty_aml_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationWidgetTextsRentalProperty_aml_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(NotificationWidgetTextsRentalProperty_aml_graphql.node, convertFragment$2, fRef);
}

var AmlFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function NotificationWidgetTexts$RentalPropertyMatchText(props) {
  var __withLinks = props.withLinks;
  var withLinks = __withLinks !== undefined ? __withLinks : false;
  var aml = use$2(props.aml);
  return JsxRuntime.jsx(AgentMatchLogTexts.RentalPropertyMatchText.make, {
              aml: aml.fragmentRefs,
              withLinks: withLinks
            });
}

var RentalPropertyMatchText = {
  AmlFragment: AmlFragment$1,
  make: NotificationWidgetTexts$RentalPropertyMatchText
};

var convertFragment$3 = NotificationWidgetTextsBuyerNeed_aml_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationWidgetTextsBuyerNeed_aml_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationWidgetTextsBuyerNeed_aml_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationWidgetTextsBuyerNeed_aml_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(NotificationWidgetTextsBuyerNeed_aml_graphql.node, convertFragment$3, fRef);
}

var AmlFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function NotificationWidgetTexts$BuyerNeedMatchText(props) {
  var __withLinks = props.withLinks;
  var withLinks = __withLinks !== undefined ? __withLinks : false;
  var aml = use$3(props.aml);
  return JsxRuntime.jsx(AgentMatchLogTexts.BuyerNeedMatchText.make, {
              aml: aml.fragmentRefs,
              withLinks: withLinks
            });
}

var BuyerNeedMatchText = {
  AmlFragment: AmlFragment$2,
  make: NotificationWidgetTexts$BuyerNeedMatchText
};

var convertFragment$4 = NotificationWidgetTextsRentalNeed_aml_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationWidgetTextsRentalNeed_aml_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationWidgetTextsRentalNeed_aml_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationWidgetTextsRentalNeed_aml_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(NotificationWidgetTextsRentalNeed_aml_graphql.node, convertFragment$4, fRef);
}

var AmlFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

function NotificationWidgetTexts$RentalNeedMatchText(props) {
  var __withLinks = props.withLinks;
  var withLinks = __withLinks !== undefined ? __withLinks : false;
  var aml = use$4(props.aml);
  return JsxRuntime.jsx(AgentMatchLogTexts.RentalNeedMatchText.make, {
              aml: aml.fragmentRefs,
              withLinks: withLinks,
              mode: props.mode
            });
}

var RentalNeedMatchText = {
  AmlFragment: AmlFragment$3,
  make: NotificationWidgetTexts$RentalNeedMatchText
};

exports.ShowingNotification = ShowingNotification;
exports.PropertyMatchText = PropertyMatchText;
exports.RentalPropertyMatchText = RentalPropertyMatchText;
exports.BuyerNeedMatchText = BuyerNeedMatchText;
exports.RentalNeedMatchText = RentalNeedMatchText;
/* IconV5 Not a pure module */
